import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { Button } from '../ui/button';

// The insufficient-credit state, app-wide (Ali, 2026-08-16: "shown in any place that charges").
// Same anatomy the prototype banner shipped with: loud, honest about what is already paid,
// top-up link, and a resume that re-runs ONLY the unfinished work (every generator's
// idempotency guarantees no double billing).
export function isCreditError(e) {
  return e?.status === 402;
}

export function CreditBanner({ onResume, testId = 'credit-banner' }) {
  const { t } = useTranslation();
  return (
    <div className="bg-destructive-soft border border-destructive-border rounded-md p-4" data-testid={testId}>
      <p className="text-sm font-semibold text-destructive flex items-center gap-2">
        <AlertCircle className="h-4 w-4 shrink-0" /> {t('credits.title')}
      </p>
      <p className="mt-1 text-sm text-destructive">{t('credits.body')}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Button size="sm" onClick={() => window.open('/settings', '_blank')} data-testid={`${testId}-topup`}>
          {t('credits.topUp')}
        </Button>
        {onResume && (
          <Button size="sm" variant="outline" onClick={onResume} data-testid={`${testId}-resume`}>
            {t('credits.resume')}
          </Button>
        )}
      </div>
    </div>
  );
}
